import { Component, Input, Output, EventEmitter} from '@angular/core';
import { Utility } from 'src/app/core/common';
import {
	IrtwadModel,
	RtwadImagePath,
	rtwadPath,
	RtwadStatus,
} from 'src/app/services/rtwad.service';
import { RtwadService } from 'src/app/services/rtwad.service';
import { finalize } from 'rxjs';

@Component({
	selector: 'app-rtwad-summary',
	templateUrl: './rtwad-summary.component.html',
	styleUrls: ['./rtwad-summary.component.scss'],
})
export class RtwadSummaryComponent {
	Utility = Utility;

	@Input() rtwad!: IrtwadModel;
	@Input() mode: 'default' | 'admin' | 'owner' = 'default';
	@Input() disableNavigate: boolean = false;

	imagePath = RtwadImagePath;
	@Input() rtwadPath = rtwadPath;
@Output() updated = new EventEmitter<IrtwadModel>();
	loadingFinish: boolean = false; // برای غیرفعال کردن دکمه حین درخواست

	constructor(private rtwadService: RtwadService) {}

	getStatusClass(status: string) {
		return {
			'green-bg': status === 'Started',
			'red-bg': status === 'Rejected',
			'yellow-bg': status === 'Pending',
			'light-gray-bg': status === 'NotPaid',
			'f-white': ['Started', 'Rejected'].includes(status),
		};
	}
ArchiveAd(event: Event) {
  event.stopPropagation();
  event.preventDefault();

  if (!this.rtwad || this.rtwad.Status === 'Archived') return;

  this.loadingFinish = true;

  const previousStatus = this.rtwad.Status;

  this.rtwadService
    .softDelete(this.rtwad.Id!)
    .then((deletedAd) => {
      this.updated.emit(deletedAd);
      console.log('آگهی با موفقیت حذف شد', deletedAd);
      this.rtwad = deletedAd;
    })
    .catch((err) => {
      console.error('خطا در حذف آگهی:', err);
      this.rtwad.Status = previousStatus;
    })
    .finally(() => {
      this.loadingFinish = false;
    });
}
}
